import { render, staticRenderFns } from "./IntelligenceBankContainer.vue?vue&type=template&id=936e16aa&scoped=true&"
import script from "./IntelligenceBankContainer.vue?vue&type=script&lang=js&"
export * from "./IntelligenceBankContainer.vue?vue&type=script&lang=js&"
import style0 from "./IntelligenceBankContainer.vue?vue&type=style&index=0&id=936e16aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936e16aa",
  null
  
)

export default component.exports